import { FormControl, InputLabel, MenuItem, Select as MuiSelect } from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

interface SelectProps {
  options: { value: string | number; label: string }[];
  value?: string | number;
  onChange: (value: string | number) => void;
  label?: string;
  size?: 'small' | 'medium';
}

const Select = ({ options, value, onChange, label, size = 'medium' }: SelectProps) => {
  const classes = useStyles();

  return (
    <FormControl className={classes.formControl} variant="outlined" size={size}>
      <InputLabel id="demo-simple-select-label">{label}</InputLabel>
      <MuiSelect
        label={label}
        labelId="demo-simple-select-label"
        id={`${label}-select`}
        value={value}
        onChange={e => onChange(e.target.value as string | number)}
      >
        {options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </MuiSelect>
    </FormControl>
  );
};

const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: 120,
  },
}));

export default Select;
